import React from 'react'
import { Box } from '@mui/material'

type AppLoadingIndicatorProps = {
  /** Đường kính vòng ngoài (px). Mặc định 52. */
  size?: number
  /** Màu chính — mặc định primary app. */
  color?: string
  /** Hiện chữ phụ dưới spinner. */
  label?: string
}

/**
 * Spinner vòng kép — dùng chung cho Ant Spin + overlay bảng list.
 * Keyframes: `.auth-loading-spin-cw` / `.auth-loading-spin-ccw` trong ThemeSwitcher.css
 */
const AppLoadingIndicator: React.FC<AppLoadingIndicatorProps> = ({
  size = 52,
  color = 'var(--color-primary, #0070f4)',
  label,
}) => {
  const track = Math.max(3, Math.round(size / 14))
  const innerSize = Math.round(size * 0.62)
  const innerTrack = Math.max(2, Math.round(track * 0.85))

  return (
    <Box
      role="status"
      aria-label={label || 'Đang tải'}
      sx={{
        display: 'inline-flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 1.25,
      }}
    >
      <Box
        sx={{
          position: 'relative',
          width: size,
          height: size,
          flexShrink: 0,
        }}
      >
        <Box
          className="auth-loading-spin-cw"
          sx={{
            position: 'absolute',
            inset: 0,
            borderRadius: '50%',
            border: `${track}px solid`,
            borderColor: 'action.hover',
            borderTopColor: color,
            borderRightColor: color,
            boxSizing: 'border-box',
          }}
        />
        <Box
          className="auth-loading-spin-ccw"
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            width: innerSize,
            height: innerSize,
            marginTop: `-${innerSize / 2}px`,
            marginLeft: `-${innerSize / 2}px`,
            borderRadius: '50%',
            border: `${innerTrack}px solid`,
            borderColor: 'transparent',
            borderBottomColor: color,
            borderLeftColor: color,
            opacity: 0.45,
            boxSizing: 'border-box',
          }}
        />
      </Box>
      {label ? (
        <Box
          component="span"
          sx={{
            fontSize: '0.8125rem',
            fontWeight: 600,
            color: 'text.secondary',
            letterSpacing: '0.02em',
          }}
        >
          {label}
        </Box>
      ) : null}
    </Box>
  )
}

export default AppLoadingIndicator
